export default __webpack_public_path__ + "static/3-87546b9133f82be49a0cf105806d82f2.png";